import { setUpGraphQLClient } from '@/lib/graphql/client';
import {
  getGsCtaAnswerQuery,
  getGsCtaQuestionQuery,
  getGsCtaServiceQuery,
} from '@/graphql/GsCtaQueries';
import {
  GsCtaAnswersFields,
  GsCtaQuestionFields,
  GsCtaServiceFields,
} from '@/types/components/gs-cta';
import { ScItem } from '@/types/sitecore';
import { merge } from 'lodash';

export const getGsCtaAnswers = async (ids: string[], lang = 'en-US') => {
  const client = setUpGraphQLClient('master');
  const res: any[] = await Promise.all(
    ids.map((id) => client.request(getGsCtaAnswerQuery(id, lang)))
  );
  console.log('getGsCtaAnswers res', res);
  return res
    .filter((x) => !!x?.item)
    .map((x) => {
      console.log('x', x);
      const service = x.item.service,
        nextQuestion = x.item.nextQuestion;
      const result = {
        id: x.item.id,
        name: x.item.name,
        displayName: x.item.displayName,
        fields: {
          text: x.item.text,
          nextQuestion: undefined,
          service: undefined,
        },
      } as ScItem<GsCtaAnswersFields>;
      if (service?.id) {
        merge(result.fields, { service: service });
      }
      if (nextQuestion?.id) {
        merge(result.fields, { nextQuestion: nextQuestion });
      }
      return result;
    });
};
export const getGsCtaService = async (id: string, lang = 'en-US') => {
  const client = setUpGraphQLClient('master');
  const res: any = await client.request(getGsCtaServiceQuery(id, lang));
  console.log('getGsCtaService res', res);
  if (!res?.item) return null;
  return {
    id: res.item.id,
    name: res.item.name,
    displayName: res.item.displayName,
    fields: {
      title: res.item.title,
      description: res.item.description,
      image: {
        value: res.item.image,
      },
      link: res.item.link,
    },
  } as ScItem<GsCtaServiceFields>;
};
export const getGsCtaQuestion = async (id: string, lang = 'en-US') => {
  const client = setUpGraphQLClient('master');
  const res: any = await client.request(getGsCtaQuestionQuery(id, lang));
  console.log('getGsCtaQuestion res', id, res);
  if (!res?.item) return null;
  return {
    id: res.item.id,
    name: res.item.name,
    displayName: res.item.displayName,
    fields: {
      question: res.item.question,
      answers: res.item.answers.targetItems.map((x: any) => {
        return {
          id: x.id,
          name: x.name,
          displayName: x.displayName,
          fields: {
            text: x.text,
            nextQuestion: x.nextQuestion,
            service: x.service,
          },
        } as ScItem<GsCtaAnswersFields>;
      }),
    },
  } as ScItem<GsCtaQuestionFields>;
};
